"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MIN_LISTBOX_WIDTH = exports.INPUT_LEFT_PADDING = exports.DEFAULT_MIN_TO_SUGGESTION = exports.DEFAULT_MAX_SUGGESTIONS = void 0;
const DEFAULT_MIN_TO_SUGGESTION = exports.DEFAULT_MIN_TO_SUGGESTION = 1;
const DEFAULT_MAX_SUGGESTIONS = exports.DEFAULT_MAX_SUGGESTIONS = 5;
const INPUT_LEFT_PADDING = exports.INPUT_LEFT_PADDING = 16;
const MIN_LISTBOX_WIDTH = exports.MIN_LISTBOX_WIDTH = 288;